import React, { ReactNode } from 'react';
import cx from 'classnames';

import styles from './styles.module.scss';

interface Props {
  key?: string;
  data: {
    subtitle: string;
    value: string | number | ReactNode;
  };
  className?: string;
  titleClassName?: string;
  valueClassName?: string;
}

function SingleContent({ data: { subtitle, value }, key, className, titleClassName, valueClassName }: Props) {
  return (
    <div key={key} className={cx(styles.gridRow, className)}>
      <h2 className={cx(styles.subtitle, titleClassName)}>{subtitle}</h2>
      <h2 className={cx(styles.value, valueClassName)}>{value || '-'}</h2>
    </div>
  );
}

export default SingleContent;
